var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"email-nav"}},[_c('nav',{staticClass:"public-nav nav"},[_c('ul',[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
            name: 'create_email'
          }}},[_vm._v("\n          Create An Email\n        ")])],1),_vm._v(" "),(_vm.emailId)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
            name: 'email',
            params: {
              emailId: _vm.emailId
            }
          }}},[_vm._v("\n          View Email\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.emailId)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
            name: 'edit_email',
            params: {
              emailId: _vm.emailId
            }
          }}},[_vm._v("\n          Edit Email\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.emailId)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
            name: 'email_recipients',
            params: {
              emailId: _vm.emailId
            }
          }}},[_vm._v("\n          Recipients\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.emailId)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
            name: 'email_stats',
            params: {
              emailId: _vm.emailId
            }
          }}},[_vm._v("\n          Stats\n        ")])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eab6f44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailNav.vue
// module id = 1222
// module chunks = 1